<template>
  <span :class="'badge badge-' + variant">{{ label }}</span>
</template>

<script>
export default {
  name: 'FulfillmentStatusBadge',
  props: {
    status: {
      type: String,
      default: null
    }
  },
  computed: {
    label() {
      const map = {
        NotStarted: 'Not Started',
        PickTicketPending: 'Pick Ticket Pending',
        PickingInProgress: 'Picking In Progress',
        NotAllocated: 'Not Allocated',
        PendingFulfillment: 'Ready to Label',
        WaitingConfirmation: 'Fully Labeled',
        ScheduledAutoconfirm: 'Scheduled Autoconfirm',
        Confirmed: 'Confirmed'
      };
      return map[this.status] || this.status || 'Unknown';
    },
    variant() {
      const map = {
        NotStarted: 'danger',
        PickTicketPending: 'secondary',
        PickingInProgress: 'secondary',
        NotAllocated: 'danger',
        PendingFulfillment: 'info',
        WaitingConfirmation: 'warning',
        ScheduledAutoconfirm: 'warning',
        Confirmed: 'success'
      };
      return map[this.status] || 'secondary';
    }
  }
};
</script>
